<app-header></app-header>

<div class="form-second-section mt-2">
  <div class="container">
    <div class="row">
      <div class="col-sm-12 sol-md-12 col-lg-6 inner-form-section">
        <h1>Forms</h1>
        <ul class="form-payment-option">
          <li class="d-flex border-right">
            <div>
              <img class="form-icon" src="/assets/book.png" alt="Book Icon" />
            </div>
            <div>
              <a
                href="https://sprucepower.wpengine.com/wp-content/uploads/2024/04/Spruce_Payment_Authorization_Form_May_2023-1.pdf"
                target="_blank"
                rel="noopener"
                >Invoice/Billing Payment Authorization Form</a
              >
            </div>
          </li>
          <li class="d-flex border-right">
            <div>
              <img class="form-icon" src="/assets/home.png" alt="Home Icon" />
            </div>
            <div>
              <a
                href="https://sprucepower.wpengine.com/wp-content/uploads/2022/09/Credit-App-Legal-0103v2.pdf"
                target="_blank"
                rel="noopener"
                >Home Sale Credit Application Form</a
              >
            </div>
          </li>
          <li class="d-flex border-right">
            <div>
              <img class="form-icon" src="/assets/debit.png" alt="Debit Icon" />
            </div>
            <div>
              <a
                href="https://sprucepower.wpengine.com/wp-content/uploads/2022/09/Consumer-Credit-Card-Authorization-Form_Spruce-Power_V2.2022.pdf"
                target="_blank"
                rel="noopener"
                >Credit Card Payment Authorization Form</a
              >
            </div>
          </li>
          <li class="d-flex border-right">
            <div>
              <img class="form-icon" src="/assets/solar.png" alt="Solar Icon" />
            </div>
            <div>
              <a
                href="https://sprucepower.wpengine.com/wp-content/uploads/2024/04/Temporary_System_Removal_Form__-2.pdf"
                target="_blank"
                rel="noopener"
                >Temporary Solar System Removal</a
              >
            </div>
          </li>
        </ul>
      </div>
      <div class="col-sm-12 sol-md-12 col-lg-6">
        <div class="form-image">
          <img src="/assets/Rectangle-2-11.jpg" alt="Form Image" />
        </div>
      </div>
    </div>
  </div>
</div>
<div class="form-select-option">
  <div class="container pt-5 pb-5">
    <div class="row pt-5 pb-5 text-center">
      <div class="col-12">
        <div class="question-section">
          <h1 class="mb-5">Other Questions or Help?</h1>
          <div class="contactus-button mt-4">
            <a [routerLink]="['/get-in-touch']">Contact Us</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
